
import React, { useEffect, useState, useRef } from "react";
import {
  Box, Button, Card, CardContent, Chip, Container, Dialog, DialogTitle,
  DialogContent, DialogActions, ListItem, List, ListItemIcon, ListItemText,
  Grid, IconButton, Paper, TextField, Typography, CircularProgress, Table,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Divider, ToggleButton, ToggleButtonGroup,
  InputAdornment, CardMedia, MenuItem, Select, FormControl, InputLabel, Collapse, Stack,TablePagination,ButtonGroup
} from "@mui/material";
import {
  Visibility, Add, Remove, Search, Receipt, Close, LocationOn, Phone,
  Image as ImageIcon, Description as FileIcon, PictureAsPdf as PdfIcon,
  Download as DownloadIcon, FilterList as FilterListIcon,ViewModule as ViewModuleIcon, TableChart as TableChartIcon,
} from "@mui/icons-material";
import Pagination from "@mui/material/Pagination";
import CustomDialog from "../../CustomDialog";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DescriptionIcon from "@mui/icons-material/Description";
import { apiRequest } from "../../fetchSetup";
import axios from 'axios';
import PaymentPendingChip from "../OrderDetailsPage/PaymentPendingChip";
import { registerFetchedOrders, isOrderUnseen, markOrderSeen } from '../../utils/orderNotifications'; 
const ADMIN_ORDERS_API = process.env.REACT_APP_ADMIN_MEDICINE_ORDERS;
const MEDICINES_API = process.env.REACT_APP_GET_MEDICINES;
const ADD_BILL_API = process.env.REACT_APP_ADMIN_ADD_BILL;
const PRESCRIPTION_LIST_API = process.env.REACT_APP_PRESCRITON_IMAGE_API_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const STATUS_COLORS = {
  pending:        { bg: "#FEF3C7", text: "#D97706" },
  bill_generated: { bg: "#DBEAFE", text: "#2563EB" },
  confirmed:      { bg: "#D1FAE5", text: "#059669" },
  cancelled:      { bg: "#FEE2E2", text: "#DC2626" },
};

export default function AdminPrescriptionOrders() {
  const [orders, setOrders] = useState([]);
  const [medicines, setMedicines] = useState([]);
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [billDialog, setBillDialog] = useState(false);
  const [detailsDialog, setDetailsDialog] = useState(false);
  const [fileDialog, setFileDialog] = useState(false);
  const [prescriptionFiles, setPrescriptionFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [billItems, setBillItems] = useState([]);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [notes, setNotes] = useState("");
  const [updating, setUpdating] = useState(false);
  const [dialog, setDialog] = useState({ open: false, message: "", type: "info", title: "Notification" });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [expandedIssues, setExpandedIssues] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [agentDetails, setAgentDetails] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  // ─── AYUJA Pricing State ──────────────────────────────────────────────────────
  const [ayujaBillPrices, setAyujaBillPrices] = useState({});   // medicine_id → selling_price (for bill dialog)
  const [ayujaBillSummary, setAyujaBillSummary] = useState(null);
  const [offeredDiscountPct, setOfferedDiscountPct] = useState(null);
  const lastFetchedBillKey = useRef("");
  const pricingPollRef = useRef(null);
  const [viewMode, setViewMode] = useState("card"); // "card" | "table"
  const [errorMsg,setErrorMsg] =useState("");
  const [communities, setCommunities] = useState([]);
  const [selectedCommunity, setSelectedCommunity]=useState("all")
  // ─────────────────────────────────────────────────────────────────────────────

  const GET_AGENT_API = `${process.env.REACT_APP_ASSGINED_DELIVERY_AGENT}`;
  const pricingFetchedRef = useRef(false);
  // ─── AYUJA: Poll pricing config every 10s ─────────────────────────────────


  useEffect(() => {
    if (pricingFetchedRef.current) return;  
    pricingFetchedRef.current = true;
  
    const POLL_EVERY = 10 * 1000;
    const CACHE_KEY = "ayujaPricingConfig";
  
    const fetchPricingConfig = async (bustCache = false) => {
      if (!bustCache) {
        try {
          const raw = sessionStorage.getItem(CACHE_KEY);
          if (raw) {
            const parsed = JSON.parse(raw);
            const age = Date.now() - (parsed._cachedAt || 0);
            if (age < POLL_EVERY && typeof parsed.configured_offered_discount_pct === "number") {
              setOfferedDiscountPct(prev =>
                prev !== parsed.configured_offered_discount_pct
                  ? parsed.configured_offered_discount_pct
                  : prev
              );
              return; // ← uses cache, NO network call
            }
          }
        } catch { }
      }
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_MEDICINE_API_URL}/pricing-config`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        if (!response.ok) { setOfferedDiscountPct(prev => prev ?? 20); return; }
        const data = await response.json();
        const newPct = data.configured_offered_discount_pct ?? 20;
        setOfferedDiscountPct(prev => (prev !== newPct ? newPct : prev));
        sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ...data, _cachedAt: Date.now() }));
      } catch {
        setOfferedDiscountPct(prev => prev ?? 20);
      }
    };
  
    fetchPricingConfig(false);
  
    //  recursive setTimeout instead of setInterval — avoids stacking
    const schedulePoll = () => {
      pricingPollRef.current = setTimeout(() => {
        fetchPricingConfig(true).then(schedulePoll);
      }, POLL_EVERY);
    };
    schedulePoll();
  
    const handleVisibility = () => {
      if (document.visibilityState === "visible") fetchPricingConfig(true);
    };
    document.addEventListener("visibilitychange", handleVisibility);
  
    return () => {
      clearTimeout(pricingPollRef.current);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  // ─── AYUJA: Fetch order-level prices whenever billItems change ────────────
  useEffect(() => {
    if (billItems.length === 0) {
      setAyujaBillPrices({});
      setAyujaBillSummary(null);
      lastFetchedBillKey.current = "";
      return;
    }

    const billKey = billItems
      .map(i => `${i.medicine_id}:${i.quantity}`)
      .sort()
      .join("|");

    if (billKey === lastFetchedBillKey.current) return;

    const fetchAyujaBillPrices = async () => {
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_MEDICINE_API_URL}/calculate-order-price`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: billItems.map(i => ({
                medicine_id: i.medicine_id,
                quantity: i.quantity,
              })),
            }),
          }
        );
        if (!response.ok) return;
        const data = await response.json();

        const priceMap = {};
        if (data.item_breakdown) {
          data.item_breakdown.forEach(item => {
            priceMap[item.medicine_id] = item.selling_price;
          });
        }
        setAyujaBillPrices(priceMap);
        setAyujaBillSummary(data);
        lastFetchedBillKey.current = billKey;
      } catch (err) {
        console.error("AYUJA admin bill price fetch error:", err);
      }
    };

    fetchAyujaBillPrices();
  }, [billItems]);

const ordersFetchedRef = useRef(false);
const medicinesFetchedRef = useRef(false);

useEffect(() => {
  const local_communities=sessionStorage.getItem('communities')
  console.log(local_communities)
  setCommunities(JSON.parse(local_communities))
  if (ordersFetchedRef.current) return;
  ordersFetchedRef.current = true;
  fetchOrders();
  fetchMedicines(); 
}, []);

  useEffect(() => {
    if (!searchQuery) {
      setFilteredMedicines(medicines);
    } else {
      const results = medicines.filter(med =>
        med.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredMedicines(results);
    }
  }, [searchQuery, medicines]);

  const statusLabelMap = {
    pending:        "Pending",
    awaiting_bill:  "Awaiting Bill",
    bill_generated: "Bill Generated",
    confirmed:      "Confirmed",
    dispatched:     "Dispatched",
    delivered:      "Delivered",
    cancelled:      "Cancelled",
  };
const handleViewModeChange = (event, newMode) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };
  const getFilteredOrders = () => {
    let filtered = [...orders];
    if (statusFilter !== "all") {
      filtered = filtered.filter(order => order.order_status === statusFilter);
    }
    if (selectedCommunity !== "all") {
      filtered = filtered.filter(order => order.delivery_address.community_name == selectedCommunity);
      console.log(filtered)
    }
    if (searchQuery.trim() !== "") {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(order =>
        order.order_id.toLowerCase().includes(query) ||
        order.patient_details?.name?.toLowerCase().includes(query) ||
        order.patient_details?.doctorname?.toLowerCase().includes(query) ||
        order.delivery_address?.community_name?.toLowerCase().includes(query) ||
        order.delivery_address?.full_name?.toLowerCase().includes(query)
      );
      console.log(filtered)
    }
    return filtered;
  };

  // ─── AYUJA Bill Pricing Helpers ───────────────────────────────────────────
  const getItemAyujaPrice = (item) => {
    const p = ayujaBillPrices[item.medicine_id];
    return p !== undefined ? p : (item.price || 0);
  };

  const getMrpSubtotal = () =>
    billItems.reduce((sum, item) => sum + (item.price || 0) * item.quantity, 0);

  const getAyujaSubtotal = () =>
    billItems.reduce((sum, item) => sum + getItemAyujaPrice(item) * item.quantity, 0);

  const getAyujaSavings = () => getMrpSubtotal() - getAyujaSubtotal();

  const calculateSubtotal = () => getAyujaSubtotal();

  const calculateTotal = () =>
    calculateSubtotal() + parseFloat(deliveryCharge || 0) - parseFloat(discount || 0);
  // ─────────────────────────────────────────────────────────────────────────

  const updateOrderStatus = async (orderId, newStatus) => {
    setUpdating(true);
    try {
      const response = await apiRequest(`${ADMIN_ORDERS_API}/${orderId}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ order_status: newStatus }),
      });
      if (!response.ok) throw new Error("Failed to update order status");
      const updatedOrders = orders.map(order =>
        order.order_id === orderId ? { ...order, order_status: newStatus } : order
      );
      setOrders(updatedOrders);
      if (selectedOrder?.order_id === orderId) {
        setSelectedOrder({ ...selectedOrder, order_status: newStatus });
      }
      showDialog("Order status updated successfully!", "success", "Success");
    } catch (err) {
      showDialog("Failed to update order status: " + err.message, "error", "Error");
    } finally {
      setUpdating(false);
    }
  };

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await apiRequest(`${ADMIN_ORDERS_API}`);
      const data = await res.json();
      const prescriptionOrders = (data.orders || []).filter(
        order => order.order_type === "prescription"
      );
      const sortedOrders = prescriptionOrders.sort((a, b) => {
        const statusPriority = {
          awaiting_bill:  1, pending: 2, bill_generated: 3, confirmed: 4,
          dispatched: 5, delivered: 6, cancelled: 7,
        };
        const priorityA = statusPriority[a.order_status] || 999;
        const priorityB = statusPriority[b.order_status] || 999;
        if (priorityA === priorityB) return new Date(b.created_at) - new Date(a.created_at);
        return priorityA - priorityB;
      });
      setOrders(prescriptionOrders);
      registerFetchedOrders('prescription', prescriptionOrders.map(o => ({ id: o.order_id, status: o.order_status })))
    } catch (error) {
      showDialog("Failed to fetch orders", "error", "Error");
    } finally {
      setLoading(false);
    }
  };

  const fetchMedicines = async () => {
    try {
      const res = await apiRequest(MEDICINES_API);
      const data = await res.json();
      const all = data.medicines || [];
      setMedicines(all);
      setFilteredMedicines(all);
    } catch (error) {
      console.error("Error fetching medicines:", error);
    }
  };

  const fetchPrescriptionFiles = async (orderId, reorderFrom = null) => {
    try {
      const orderIdToFetch = reorderFrom || orderId;
      const res = await apiRequest(`${PRESCRIPTION_LIST_API}/${orderIdToFetch}`);
      const data = await res.json();
      if (data.success && data.files) {
        setPrescriptionFiles(data.files);
        return data.files;
      }
      setPrescriptionFiles([]);
      return [];
    } catch (error) {
      showDialog("Failed to load prescription files", "error", "Error");
      setPrescriptionFiles([]);
      return [];
    }
  };

  const getFileType = (url) => {
    if (!url) return "unknown";
    const extension = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";
    if (["doc", "docx"].includes(extension)) return "document";
    return "unknown";
  };

  const getFileIcon = (fileType) => {
    switch (fileType) {
      case "image":    return <ImageIcon />;
      case "pdf":      return <PdfIcon />;
      case "document": return <FileIcon />;
      default:         return <FileIcon />;
    }
  };

  const fetchOriginalOrderItems = async (originalOrderId) => {
    try {
      const res = await apiRequest(`${ADMIN_ORDERS_API}/${originalOrderId}`);
      const data = await res.json();
      if (data.order && data.order.items && data.order.items.length > 0) {
        return data.order.items;
      }
      return [];
    } catch (error) {
      showDialog("Failed to load original order items", "error", "Error");
      return [];
    }
  };
// Add a cache ref at top of component
const prescriptionCache = useRef({});
const agentCache = useRef({});

//  FIX openDetailsDialog — cache prescription files per order
const openDetailsDialog = async (order) => {
  markOrderSeen('prescription', order.order_id); 
  setSelectedOrder(order);
  setDetailsDialog(true); // ← open dialog immediately, don't wait

  // Use cached prescription files if available
  if (prescriptionCache.current[order.order_id]) {
    setPrescriptionFiles(prescriptionCache.current[order.order_id]);
  } else {
    const files = await fetchPrescriptionFiles(order.order_id, order.reorder_from);
    prescriptionCache.current[order.order_id] = files; // ← cache it
  }

  // Use cached agent if available
  if (order.assigned_agent_id) {
    if (agentCache.current[order.assigned_agent_id]) {
      setAgentDetails(agentCache.current[order.assigned_agent_id]);
    } else {
      const details = await fetchAgentDetails(order.assigned_agent_id);
      // fetchAgentDetails already sets state, just cache:
      agentCache.current[order.assigned_agent_id] = agentDetails;
    }
  } else {
    setAgentDetails(null);
  }
};

//  FIX openBillDialog — same cache
const openBillDialog = async (order) => {
   markOrderSeen('prescription', order.order_id);
  setSelectedOrder(order);
  setDeliveryCharge(0);
  setDiscount(0);
  setNotes("");
  setAyujaBillPrices({});
  setAyujaBillSummary(null);
  lastFetchedBillKey.current = "";

  // Use cached prescription files
  if (prescriptionCache.current[order.order_id]) {
    setPrescriptionFiles(prescriptionCache.current[order.order_id]);
  } else {
    const files = await fetchPrescriptionFiles(order.order_id, order.reorder_from);
    prescriptionCache.current[order.order_id] = files;
  }

  if (order.reorder_from) {
    const originalItems = await fetchOriginalOrderItems(order.reorder_from);
    if (originalItems && originalItems.length > 0) {
      setBillItems(originalItems.map(item => ({
        medicine_id: item.medicine_id,
        medicine_name: item.medicine_name,
        quantity: item.quantity,
        price: item.unit_price || item.price || (item.total_price / item.quantity),
        manufacturer:item.manufacturer,
        schedule:item.schedule
      })));
    } else {
      setBillItems([]);
    }
  } else {
    setBillItems([]);
  }
  setBillDialog(true);
};


  const openFileDialog = (fileUrl) => {
    if (fileUrl.startsWith("http")) {
      setSelectedFile(fileUrl);
      setFileDialog(true);
      return;
    }
    let fullUrl;
    if (fileUrl.startsWith("/prescriptions/")) {
      fullUrl = `${BACKEND_URL}/api/flask/prescription${fileUrl}`;
    } else {
      const cleanUrl = fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`;
      fullUrl = `${BACKEND_URL}/api/flask/prescription/prescriptions${cleanUrl}`;
    }
    setSelectedFile(fullUrl);
    setFileDialog(true);
  };

  const getFileUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    if (url.startsWith("/prescriptions/")) return `${BACKEND_URL}/api/flask/prescription${url}`;
    const cleanUrl = url.startsWith("/") ? url : `/${url}`;
    return `${BACKEND_URL}/api/flask/prescription/prescriptions${cleanUrl}`;
  };

  const addMedicineToBill = (medicine) => {
    const existing = billItems.find(item => item.medicine_id === medicine.medicine_id);
    if (existing) {
      setBillItems(billItems.map(item =>
        item.medicine_id === medicine.medicine_id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setBillItems([
        ...billItems,
        {
          medicine_id: medicine.medicine_id,
          medicine_name: medicine.name,
          name:medicine.name,
          quantity: 1,
          price: medicine.mrp || medicine.price,
          hsn_code:medicine.hsn_code,
          batch_number:medicine.batch_number,
          expiry_date:medicine.expiry_date,
          cgst:medicine.cgst,
          sgst:medicine.sgst,
          igst:medicine.igst,
          base_price:medicine.base_price,
          manufacturer:medicine.manufacturer,
          schedule:medicine.schedule

        },
      ]);
    }
  };

  const updateQuantity = (medicineId, newQuantity) => {
    if (newQuantity < 1) {
      setBillItems(billItems.filter(item => item.medicine_id !== medicineId));
    } else {
      setBillItems(billItems.map(item =>
        item.medicine_id === medicineId ? { ...item, quantity: newQuantity } : item
      ));
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  const paginatedOrders = getFilteredOrders().slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  // ─── GST calculation (AYUJA-aware) ───────────────────────────────────────
  const calculateItemGST = (item) => {
    const cgst = item.cgst || 0;
    const sgst = item.sgst || 0;
    const igst = item.igst || 0;
    const gstRate = igst > 0 ? igst : (cgst + sgst);
    const totalPrice = item.total_price || 0;
    const basePrice = totalPrice / (1 + gstRate / 100);
    const gstAmount = totalPrice - basePrice;
    return {
      cgst, sgst, igst, gstRate, basePrice, gstAmount,
      cgstAmount: igst > 0 ? 0 : gstAmount / 2,
      sgstAmount: igst > 0 ? 0 : gstAmount / 2,
      igstAmount: igst > 0 ? gstAmount : 0,
      totalPrice,
    };
  };

  const calculateOrderGST = (items) => {
    let totalBasePrice = 0, totalCGST = 0, totalSGST = 0, totalIGST = 0, totalGST = 0;
    items.forEach(item => {
      const itemGST = calculateItemGST(item);
      totalBasePrice += itemGST.basePrice;
      totalCGST += itemGST.cgstAmount;
      totalSGST += itemGST.sgstAmount;
      totalIGST += itemGST.igstAmount;
      totalGST += itemGST.gstAmount;
    });
    return { basePrice: totalBasePrice, cgst: totalCGST, sgst: totalSGST, igst: totalIGST, totalGST };
  };

  // Bill-level GST using AYUJA prices for billItems
  const calculateBillGST = () => {
    let totalBasePrice = 0, totalCGST = 0, totalSGST = 0, totalIGST = 0, totalGST = 0;
    billItems.forEach(item => {
      const medicine = medicines.find(m => m.medicine_id === item.medicine_id);
      const cgst = medicine?.cgst || 0;
      const sgst = medicine?.sgst || 0;
      const igst = medicine?.igst || 0;
      const gstRate = igst > 0 ? igst : (cgst + sgst);
      const sellingPrice = getItemAyujaPrice(item);
      const totalPrice = sellingPrice * item.quantity;
      const basePrice = totalPrice / (1 + gstRate / 100);
      const gstAmount = totalPrice - basePrice;
      totalBasePrice += basePrice;
      totalGST += gstAmount;
      if (igst > 0) { totalIGST += gstAmount; }
      else { totalCGST += gstAmount / 2; totalSGST += gstAmount / 2; }
    });
    return { basePrice: totalBasePrice, cgst: totalCGST, sgst: totalSGST, igst: totalIGST, totalGST };
  };
  // ─────────────────────────────────────────────────────────────────────────

  const handleGenerateBill = async () => {
    if (billItems.length === 0) {
      showDialog("Please add at least one medicine", "warning", "Warning");
      return;
    }
    try {
      // Embed AYUJA selling prices into items before sending
      const itemsWithAyuja = billItems.map(item => ({
        ...item,
        unit_price: getItemAyujaPrice(item),
      }));

      const payload = {
        items: itemsWithAyuja,
        delivery_charge: parseFloat(deliveryCharge || 0),
        discount: parseFloat(discount || 0),
        notes: notes,
        prescription_verified: true,
        ayuja_summary: ayujaBillSummary || null,
      };

      const res = await apiRequest(`${ADD_BILL_API}/${selectedOrder.order_id}/add-bill`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (res.ok) {
          const subtotal = data.order.order_pricing?.totalMRP || 0;
          const finalDiscount = data.order.order_pricing?.totalDiscountValue || 0;
          const totalAmount = data.total_amount || 0;
          console.log(finalDiscount)
        showDialog("Bill generated successfully!", "success", "Success");
const community_name=sessionStorage.getItem('user')
    const community=JSON.parse(community_name).address.community_name
        const posOrderData={ 
        service_type:"medicine",
          order_id: selectedOrder.order_id,
          items: billItems,
          patient_details: selectedOrder.patient_details,
          subtotal: subtotal,
          discount: finalDiscount,
          total_amount: totalAmount,
          community_name:community,
          delivery_charge:deliveryCharge,
          payment: { method: selectedOrder.payment.method },
          created_at: new Date().toISOString(),
          batchInfo:data.stock_deduction 
        }
        console.log(posOrderData)
          try {
            const invoice_response = await axios.post(
              `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
              posOrderData,
            );
      
          const invoice = invoice_response.data.invoice_details;
          if (invoice.storage_type === "s3") {
            // Open CloudFront URL
            window.open(invoice.cloudfront_url, "_blank");
          } else if (invoice.storage_type === "local") {
            try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/invoice/download/${posOrderData.order_id}`,
              {
                responseType: "blob",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");

          } catch (error) {
            console.error("Invoice download failed:", error);
          }
          }
          } catch (error) {
            console.error("Invoice generation failed:", error);
          }

        
        setBillDialog(false);
        fetchOrders();
      } else {
        const error = data.error
        setErrorMsg(error)
        showDialog(error || "Failed to generate bill", "error", "Error");
      }
    } catch  {
      showDialog("Error generating bill", "error", "Error");
    }
  };

  const showDialog = (message, type = "info", title = "Notification") => {
    setDialog({ open: true, message, type, title });
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

  const formatDateTime = (isoTime) =>
    new Date(isoTime).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit", hour12: true,
    });

  const extractFilenameFromUrl = (url) => {
    if (!url) return null;
    try {
      const cleanUrl = url.split("?")[0];
      const parts = cleanUrl.split("/").filter(Boolean);
      return parts.pop();
    } catch (e) { return null; }
  };
  const handleInvoiceDownload=async(order_id)=>{
        try {
              const token = sessionStorage.getItem("token");
  
              const response = await axios.get(
                `${process.env.REACT_APP_API_INVOICE}/invoice/download/${order_id}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              
            const download_url=response.data.download_url
              window.open(download_url, "_blank");
  
            } catch (error) {
              console.error("Invoice download failed:", error);
            }
  }
  // ─── Print Invoice (prescription orders – AYUJA-aware) ────────────────────
  const handlePrintInvoice = async() => {
    if (!selectedOrder || !selectedOrder.items || selectedOrder.items.length === 0) {
      showDialog("No order items to print", "warning", "Warning");
      return;
    }
    handleInvoiceDownload(selectedOrder.order_id)
    

  //   const invoiceContent = generateInvoiceHTML(selectedOrder);
  //   const printWindow = window.open("", "_blank");
  //   printWindow.document.write(invoiceContent);
  //   printWindow.document.close();
  //   printWindow.focus();
  //   setTimeout(() => printWindow.print(), 250);
  // };
  }


  const handleDownloadPrescription = async (orderId, fileUrlOrName) => {
    try {
      if (!orderId || !fileUrlOrName) { showDialog("Invalid download parameters", "error", "Error"); return; }
      const filename = fileUrlOrName.includes("/") ? fileUrlOrName.split("/").pop() : fileUrlOrName;
      const apiUrl = `${BACKEND_URL}/api/flask/prescription/prescription-download/${orderId}/${encodeURIComponent(filename)}`;
      const res = await apiRequest(apiUrl);
      if (!res.ok) { const text = await res.text(); throw new Error(text || "Failed to get download URL"); }
      const data = await res.json();
      const downloadUrl = data.download_url || data["download_url "] || data.url;
      if (!downloadUrl) throw new Error("Download URL missing from response");
      window.open(downloadUrl, "_blank");
    } catch (err) {
      showDialog("Failed to download prescription", "error", "Error");
    }
  };


  const fetchAgentDetails = async (agentId) => {
    if (!agentId) { setAgentDetails(null); return null; }
  
    // Return cached if available
    if (agentCache.current[agentId]) {
      setAgentDetails(agentCache.current[agentId]);
      return agentCache.current[agentId];
    }
  
    setLoadingAgent(true);
    try {
      const response = await apiRequest(`${GET_AGENT_API}/${agentId}`);
      if (response.ok) {
        const data = await response.json();
        agentCache.current[agentId] = data; 
        setAgentDetails(data);
        return data;
      } else {
        setAgentDetails(null);
        return null;
      }
    } catch (error) {
      setAgentDetails(null);
      return null;
    } finally {
      setLoadingAgent(false);
    }
  };
  const FilePreview = ({ file, onClick }) => {
    const fileType = getFileType(file.url);
    const fileUrl = getFileUrl(file.url);
    return (
      <Card elevation={2} sx={{ cursor: "pointer", transition: "all 0.2s", "&:hover": { transform: "scale(1.05)", boxShadow: 6 } }} onClick={onClick}>
        {fileType === "image" ? (
          <CardMedia component="img" height="200" image={fileUrl} alt={file.filename || "Prescription"} sx={{ objectFit: "contain", bgcolor: "#f8fafc" }}
            onError={(e) => { e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><text x="50%" y="50%" text-anchor="middle" fill="%23999">Image not found</text></svg>'; }} />
        ) : (
          <Box sx={{ height: 200, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", bgcolor: "#f8fafc", gap: 2 }}>
            <Box sx={{ fontSize: 60, color: "#006D77" }}>{getFileIcon(fileType)}</Box>
            <Typography sx={{ fontSize: 14, color: "#64748b", fontWeight: 600 }}>{fileType.toUpperCase()} File</Typography>
          </Box>
        )}
        <CardContent sx={{ py: 1, textAlign: "center" }}>
          <Typography sx={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
            {getFileIcon(fileType)} {file.filename || `File ${fileType}`}
          </Typography>
          <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>Click to {fileType === "image" || fileType === "pdf" ? "view" : "download"}</Typography>
        </CardContent>
      </Card>
    );
  };

  const FileViewer = () => {
    if (!selectedFile) return <Typography>No file selected</Typography>;
    const fileType = getFileType(selectedFile);
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "500px", bgcolor: "#f8fafc", p: 2 }}>
        {fileType === "image" && (
          <img src={selectedFile} alt="Prescription" style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
            onError={(e) => { e.target.onerror = null; e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400"><rect width="400" height="400" fill="%23f0f0f0"/><text x="50%" y="50%" text-anchor="middle" fill="%23999" font-size="20">Image not found</text></svg>'; }} />
        )}
        {fileType === "pdf" && <iframe src={selectedFile} style={{ width: "100%", height: "80vh", border: "none" }} title="PDF Viewer" />}
        {(fileType === "document" || fileType === "unknown") && (
          <Box sx={{ textAlign: "center", p: 4 }}>
            <Box sx={{ fontSize: 80, color: "#64748b", mb: 2 }}><FileIcon sx={{ fontSize: 80 }} /></Box>
            <Typography sx={{ fontSize: 18, color: "#1e293b", mb: 2 }}>File preview not available</Typography>
            <Button variant="contained" startIcon={<DownloadIcon />} href={selectedFile} download target="_blank" sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#005A63" } }}>Download File</Button>
          </Box>
        )}
      </Box>
    );
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", bgcolor: "#f8fafc" }}>
        <CircularProgress size={60} sx={{ color: "#006D77" }} />
      </Box>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4, bgcolor: "#f8fafc", minHeight: "100vh" }}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>

        <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", md: "center" },
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
    mb: 3
  }}
>
  {/* Left Section */}
  <Box>
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        color: "#006D77",
        fontSize: { xs: "1.3rem", sm: "1.5rem" }
      }}
    >
      Prescription Orders Management
    </Typography>

    {offeredDiscountPct !== null && (
      <Chip
        label={`🎯 Up to ${offeredDiscountPct}% OFF via AYUJA`}
        size="small"
        sx={{
          mt: 1,
          bgcolor: "#fff7ed",
          color: "#ea580c",
          fontWeight: 700,
          border: "1px solid #fed7aa",
          fontSize: "0.75rem"
        }}
      />
    )}
  </Box>

  {/* Right Section */}
  <Box
    sx={{
      display: "flex",
      alignItems: { xs: "stretch", sm: "center" },
      justifyContent: "flex-end",
      flexDirection: { xs: "column", sm: "row" },
      gap: 2,
      width: { xs: "100%", md: "auto" }
    }}
  >
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        order: { xs: 2, sm: 1 },
        textAlign: { xs: "center", sm: "right" },
        fontSize: { xs: "0.85rem", sm: "0.95rem" }
      }}
    >
      ({getFilteredOrders().length} of {orders.length} orders)
    </Typography>

    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={handleViewModeChange}
      sx={{
        order: { xs: 1, sm: 2 },
        bgcolor: "white",
        alignSelf: { xs: "stretch", sm: "center" },

        "& .MuiToggleButton-root": {
          border: "1px solid #E0E0E0",
          textTransform: "none",
          px: { xs: 1.5, sm: 2 },
          py: 1,
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
          flex: { xs: 1, sm: "unset" },

          "&.Mui-selected": {
            bgcolor: "#006D77",
            color: "white",

            "&:hover": {
              bgcolor: "#005560"
            }
          }
        }
      }}
    >
      <ToggleButton value="card">
        <ViewModuleIcon sx={{ mr: 1, fontSize: 20 }} />
        Card View
      </ToggleButton>

      <ToggleButton value="table">
        <TableChartIcon sx={{ mr: 1, fontSize: 20 }} />
        Table View
      </ToggleButton>
    </ToggleButtonGroup>
  </Box>
</Box>

        {/* SEARCH AND FILTER */}
        <Paper sx={{ p: 2, mb: 3, display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center", bgcolor: "#f8fafc" }}>
          <TextField
            placeholder="Search by Order ID, Patient Name, Doctor Name, Address..."
            variant="outlined" size="small" value={searchQuery}
            // onChange={(e) => setSearchQuery(e.target.value)}
            onChange={(e) => { setSearchQuery(e.target.value); setPage(0); }}
            sx={{ flex: { xs: "1 1 100%", sm: "1 1 auto" }, minWidth: { xs: "100%", sm: "300px" }, "& .MuiOutlinedInput-root": { bgcolor: "white" } }}
            InputProps={{ startAdornment: <InputAdornment position="start"><Search sx={{ color: "#006D77" }} /></InputAdornment> }}
          />
               <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel id="status-filter-label">
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <FilterListIcon fontSize="small" />
                            Filter by Community
                          </Box>
                        </InputLabel>
                        <Select
                          labelId="status-filter-label"
                          value={selectedCommunity}
                          label="Filter by Community"
                          onChange={(e) => {
                            setSelectedCommunity(e.target.value);
                            setPage(0); // Reset to first page on filter change
                          }}
                          sx={{ bgcolor: 'white' }}
                        >
                          <MenuItem value="all">Community</MenuItem>
                            {communities.map((community) => (
                              <MenuItem
                                key={community.name}
                                value={community.name}
                              >
                                {community.name}
                              </MenuItem>
                            ))}
            
                            </Select>
                      </FormControl>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel id="status-filter-label">
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}><FilterListIcon fontSize="small" /> Filter by Status</Box>
            </InputLabel>
            <Select labelId="status-filter-label" value={statusFilter} label="Filter by Status" 
            // onChange={(e) => setStatusFilter(e.target.value)} 
            onChange={(e) => { setStatusFilter(e.target.value); setPage(0); }}
            sx={{ bgcolor: "white" }}>
              <MenuItem value="all">All Statuses</MenuItem>
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="awaiting_bill">Awaiting Bill</MenuItem>
              <MenuItem value="bill_generated">Bill Generated</MenuItem>
              <MenuItem value="confirmed">Confirmed</MenuItem>
              <MenuItem value="dispatched">Dispatched</MenuItem>
              <MenuItem value="delivered">Delivered</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
            </Select>
          </FormControl>
          {(searchQuery || selectedCommunity!== "all" || statusFilter !== "all") && (
            <Button variant="outlined" size="small" onClick={() => { setSearchQuery(""); setStatusFilter("all");setSelectedCommunity("all") }}
              sx={{ borderColor: "#006D77", color: "#006D77", textTransform: "none", "&:hover": { borderColor: "#005560", bgcolor: "rgba(0,109,119,0.04)" } }}>
              Clear Filters
            </Button>
          )}
        </Paper>

        {getFilteredOrders().length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <Typography sx={{ fontSize: 18, color: "#64748b", mt: 2 }}>
              {searchQuery ||selectedCommunity!== "all" || statusFilter !== "all" ? "No orders match your search criteria" : "No prescription orders found"}
            </Typography>
            {(searchQuery ||selectedCommunity!== "all" || statusFilter !== "all") && (
              <Typography sx={{ fontSize: 14, color: "#94a3b8", mt: 1 }}>Try adjusting your search or filter criteria</Typography>
            )}
          </Box>
        ) : (
          <>
           {viewMode === "card" ? (
          <Grid container spacing={3}>
            {/* {getFilteredOrders().map((order) => { */}
              {paginatedOrders.map((order) => {
              if (!order || !order.patient_details || !order.delivery_address) return null;
              const isReorder = !!order.reorder_from;
              const isNew = isOrderUnseen('prescription', order.order_id);
              return (
                <Grid item xs={12} sm={6} key={order.order_id} alignItems="stretch">
                  <Card elevation={0} sx={{
                    width: "360px", display: "flex", flexDirection: "column", borderRadius: 2.5,
                    border: isNew ? "2px solid #f8e7e7" : (isReorder ? "1px solid #006d77" : "1px solid #e2e8f0"), // ← CHANGED
                    bgcolor: isNew ? "#FEF2F2" : "#fff", // ← CHANGED
                    transition: "all 0.3s ease", overflow: "hidden", position: "relative",
                    "&:hover": { transform: "translateY(-4px)", boxShadow: "0 12px 24px rgba(0,0,0,0.08)", borderColor: isNew ? "#f1b4b4" : "#006d77" }, // ← CHANGED
                  }}>
                    {isReorder && (
                      <Chip label="Reorder" size="small" sx={{ position: "absolute", top: 40, right: 10, bgcolor: "#F3E8FF", color: "#006d77", fontWeight: 700, fontSize: "0.7rem", zIndex: 1 }} />
                    )}
                    <CardContent>
                    
                      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                          <Box>
                            <Typography sx={{ fontSize: 14, color: "#64748b" }}>
                              {order.order_id}
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: "#94a3b8" }}>
                              {formatDate(order.created_at)}
                            </Typography>
                            {isReorder && (
                              <Typography sx={{ fontSize: 11, color: "#006d77", fontWeight: 600, mt: 0.5, }} >
                                From: {order.reorder_from}
                              </Typography>
                            )}
                          </Box>

                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1 }}>
                            <Chip label={order.order_status.replace("_", " ").toUpperCase()}
                              sx={{ bgcolor: STATUS_COLORS[order.order_status]?.bg, color: STATUS_COLORS[order.order_status]?.text, fontWeight: 600, }}
                            />
                            <PaymentPendingChip order={order} apiFetch={apiRequest} notify={showDialog} />
                          </Box>
                        </Box>

                      {order.delivery_address?.delivery_time && (
                        <Typography sx={{ fontSize: 14, color: "#1e293b", mb: 1 }}>
                          <strong>Delivery Time:</strong>{" "}
                          {isNaN(new Date(order.delivery_address.delivery_time))
                            ? order.delivery_address.delivery_time
                            : formatDateTime(order.delivery_address.delivery_time)}
                        </Typography>
                      )}

                      <Divider sx={{ my: 2 }} />
                      <Typography sx={{ fontSize: 14, color: "#1e293b", mb: 1 }}><strong>Name:</strong> {order.patient_details?.name || "N/A"}</Typography>
                      <Typography sx={{ fontSize: 14, color: "#1e293b", mb: 1 }}><strong>Age:</strong> {order.patient_details?.age || "N/A"}</Typography>
                      <Typography sx={{ fontSize: 14, color: "#1e293b", mb: 1 }}><strong>Gender:</strong> {order.patient_details?.gender || "N/A"}</Typography>
                      <Typography sx={{ fontSize: 14, color: "#1e293b", mb: 1 }}><strong>Doctor Name:</strong> {order.patient_details?.doctorname || "N/A"}</Typography>
                      <Typography sx={{ fontSize: 14, color: "#1e293b", mb: 1 }}
                        dangerouslySetInnerHTML={{
                          __html: `<strong>Address:</strong><br/>${[
                            order.delivery_address?.community_name && `Community: ${order.delivery_address.community_name}`,
                            order.delivery_address?.address_line1 && `Block: ${order.delivery_address.address_line1}`,
                            order.delivery_address?.address_line2 && `Flat No: ${order.delivery_address.address_line2}`,
                            order.delivery_address?.delivery_time && `Time: ${formatDateTime(order.delivery_address.delivery_time)}`
                          ].filter(Boolean).join("<br/>")}`
                        }}
                      />

                      {order.total_amount > 0 && (
                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#006D77", mt: 2 }}>
                          Total: ₹{order.total_amount.toFixed(2)}
                        </Typography>
                      )}

                      <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                        {["pending", "awaiting_bill"].includes(order.order_status) && (
                          <Button variant="contained" startIcon={<Receipt />} onClick={() => openBillDialog(order)}
                            sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#005A63" } }}>
                            Generate Bill
                          </Button>
                        )}
                        <Button variant="outlined" startIcon={<Visibility />} onClick={() => openDetailsDialog(order)}
                          sx={{ color: "#006D77", borderColor: "#006D77", textTransform: "none" }}>
                          View Details
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>):(<TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: "1px solid #E2E8F0",
          borderRadius: 3,
          overflowX: "auto"
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#F8FAFC" }}>
              <TableCell><strong>Order ID</strong></TableCell>
              <TableCell><strong>Date</strong></TableCell>
              <TableCell><strong>Patient</strong></TableCell>
              <TableCell><strong>Doctor</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Total</strong></TableCell>
              <TableCell align="center"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedOrders.map((order) => {
              if ( !order || !order.patient_details || !order.delivery_address) return null;
              const isNew = isOrderUnseen('prescription', order.order_id);

              return (
                <TableRow
                  key={order.order_id}
                  hover
                  sx={{ bgcolor: isNew ? "#FEF2F2" : "inherit", "&:hover": { bgcolor: isNew ? "#FEE2E2" : "#F8FAFC" } }}> 
                  <TableCell>{order.order_id}</TableCell>

                  <TableCell>
                    {formatDate(order.created_at)}
                  </TableCell>

                  <TableCell>
                    {order.patient_details?.name || "N/A"}
                  </TableCell>

                  <TableCell>
                    {order.patient_details?.doctorname || "N/A"}
                  </TableCell>

                  <TableCell>
                    <Chip
                      size="small"
                      label={order.order_status
                        .replace("_", " ")
                        .toUpperCase()}
                      sx={{
                        bgcolor: STATUS_COLORS[order.order_status]?.bg,
                        color: STATUS_COLORS[order.order_status]?.text,
                        fontWeight: 600
                      }}
                    />
                     <PaymentPendingChip order={order} apiFetch={apiRequest} notify={showDialog} />
                  </TableCell>

                  <TableCell>
                    ₹{order.total_amount?.toFixed(2) || "0.00"}
                  </TableCell>

                  <TableCell align="center">
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        justifyContent: "center"
                      }}
                    >
                      {["pending", "awaiting_bill"].includes(
                        order.order_status
                      ) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => openBillDialog(order)}
                          sx={{
                            bgcolor: "#006D77",
                            textTransform: "none",
                            minWidth: "unset"
                          }}
                        >
                          Bill
                        </Button>
                      )}

                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => openDetailsDialog(order)}
                        sx={{
                          color: "#006D77",
                          borderColor: "#006D77",
                          textTransform: "none",
                          minWidth: "unset"
                        }}
                      >
                        View
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>)}


<Stack spacing={2} alignItems="center" sx={{ mt: 3, mb: 2 }}>
  <Pagination
    count={Math.ceil(getFilteredOrders().length / rowsPerPage)}
    page={page + 1}
    onChange={(e, value) => setPage(value - 1)}
    shape="rounded"
    color="primary"
    sx={{
      "& .MuiPaginationItem-root": {
        fontWeight: 600,
        borderRadius: 10
      },

      "& .Mui-selected": {
        bgcolor: "#006D77 !important",
        color: "#fff"
      },

    }}
  />
</Stack>

</>
        )}
      </Paper>

      {/* ═══════════════════════════════════════════════════════════════════════
          GENERATE BILL DIALOG  (AYUJA-integrated)
          ═══════════════════════════════════════════════════════════════════ */}
      <Dialog open={billDialog} onClose={() => setBillDialog(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ bgcolor: "#006D77", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Generate Bill
          <IconButton onClick={() => setBillDialog(false)} sx={{ color: "#fff" }}><Close /></IconButton>
        </DialogTitle>

        {/* Reorder notice */}
        {selectedOrder?.reorder_from && billItems.length > 0 && (
          <Box sx={{ px: 3, pt: 2 }}>
            <Paper elevation={0} sx={{ bgcolor: "#E0F2F1", p: 2, borderRadius: 2 }}>
              <Typography sx={{ color: "#006D77", fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}>
                <Receipt /> Reorder from {selectedOrder.reorder_from}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "#00796B", mt: 1 }}>
                {billItems.length} items loaded from previous order. You can modify quantities or add more medicines.
              </Typography>
            </Paper>
          </Box>
        )}

        {/* AYUJA savings banner */}
        {getAyujaSavings() > 0 && (
          <Box sx={{ px: 3, pt: 2 }}>
            <Paper elevation={0} sx={{ bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", p: 2, borderRadius: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography sx={{ color: "#16a34a", fontWeight: 700 }}>
                  🎯 AYUJA Savings Applied
                </Typography>
                <Typography sx={{ color: "#16a34a", fontWeight: 700, fontSize: 16 }}>
                  Save ₹{getAyujaSavings().toFixed(2)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                <Typography sx={{ fontSize: 13, color: "#64748b" }}>
                  MRP Total:{" "}
                  <span style={{ textDecoration: "line-through", color: "#9CA3AF" }}>
                    ₹{getMrpSubtotal().toFixed(2)}
                  </span>
                </Typography>
                <Typography sx={{ fontSize: 13, color: "#16a34a", fontWeight: 600 }}>
                  AYUJA Price: ₹{getAyujaSubtotal().toFixed(2)}
                </Typography>
              </Box>
              {ayujaBillSummary?.alpha && (
                <Typography sx={{ fontSize: 11, color: "#9a3412", mt: 0.5 }}>
                  Alpha Factor: {ayujaBillSummary.alpha} | Final Discount: {ayujaBillSummary.final_discount_pct}%
                </Typography>
              )}
            </Paper>
          </Box>
        )}

        <DialogContent sx={{ pt: 3 }}>

          {/* Preferred Medicines */}
          {selectedOrder?.preferred_medicines && selectedOrder.preferred_medicines.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Paper elevation={0} sx={{ bgcolor: "#FFF8E1", border: "1px solid #FFD54F", borderRadius: 2, p: 2 }}>
                <Typography sx={{ fontWeight: 600, color: "#E65100", fontSize: 14, mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
                  ⭐ Patient's Preferred Medicines
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                  {selectedOrder.preferred_medicines.map((med, idx) => (
                    <Chip key={idx} label={med} size="small"
                      sx={{ bgcolor: "#E0F2F1", color: "#00695C", fontWeight: 600, fontSize: "0.75rem", border: "1px solid #80CBC4" }} />
                  ))}
                </Box>
              </Paper>
            </Box>
          )}

          {/* Prescription Files */}
          {prescriptionFiles.length > 0 ? (
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}>
                <FileIcon /> Prescription Files ({prescriptionFiles.length})
              </Typography>
              <Grid container spacing={2}>
                {prescriptionFiles.map((file, idx) => (
                  <Grid item xs={12} sm={6} md={4} key={`prescription-${selectedOrder?.order_id}-${idx}`}>
                    <FilePreview file={file} onClick={() => openFileDialog(file.url)} />
                  </Grid>
                ))}
              </Grid>
              <Divider sx={{ my: 3 }} />
            </Box>
          ) : (
            <Box sx={{ mb: 3, p: 3, bgcolor: "#FEF3C7", borderRadius: 2, textAlign: "center" }}>
              <Typography sx={{ color: "#D97706" }}>⚠️ No prescription files found for this order</Typography>
            </Box>
          )}

          {/* Search Medicines */}
          <TextField fullWidth placeholder="Search medicines..." value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{ startAdornment: <InputAdornment position="start"><Search /></InputAdornment> }}
            sx={{ mb: 3 }}
          />

          {/* Medicine Search Results — Table */}
          {searchQuery && (
            <Paper elevation={0} sx={{ mb: 3, maxHeight: 320, overflow: "auto", border: "1px solid #e2e8f0", borderRadius: 2 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ bgcolor: "#006D77", color: "#fff", fontWeight: 700 }}>Medicine Name</TableCell>
                    <TableCell sx={{ bgcolor: "#006D77", color: "#fff", fontWeight: 700 }}>Category</TableCell>
                    <TableCell align="right" sx={{ bgcolor: "#006D77", color: "#fff", fontWeight: 700 }}>MRP</TableCell>
                    <TableCell align="right" sx={{ bgcolor: "#006D77", color: "#fff", fontWeight: 700 }}>AYUJA Price</TableCell>
                  
                    <TableCell align="center" sx={{ bgcolor: "#006D77", color: "#fff", fontWeight: 700 }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMedicines.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 3, color: "#64748b" }}>
                        No medicines found
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredMedicines.map((med) => {
                      const inCart = billItems.find(i => i.medicine_id === med.medicine_id);
                      const ayujaPrice = inCart ? ayujaBillPrices[med.medicine_id] : null;
                      const mrpPrice = med.mrp || med.price || 0;
                      const hasDiscount = ayujaPrice !== null && ayujaPrice < mrpPrice;
                      const discPct = hasDiscount ? (((mrpPrice - ayujaPrice) / mrpPrice) * 100).toFixed(1) : null;
                      return (
                        <TableRow key={`medicine-${med.medicine_id}`}
                          sx={{
                            bgcolor: inCart ? "#f0fdf4" : "white",
                            "&:hover": { bgcolor: inCart ? "#dcfce7" : "#f0fdfa" },
                            cursor: "pointer",
                          }}
                          onClick={() => addMedicineToBill(med)}
                        >
                          <TableCell>
                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{med.name}</Typography>
                            {inCart && <Chip label="In Bill" size="small" sx={{ fontSize: "0.6rem", bgcolor: "#d1fae5", color: "#059669", height: 16, mt: 0.3 }} />}
                          </TableCell>
                          <TableCell sx={{ fontSize: 12, color: "#64748b" }}>{med.drug_type || "—"}</TableCell>
                          <TableCell align="right">
                            {hasDiscount
                              ? <span style={{ textDecoration: "line-through", color: "#9CA3AF", fontSize: 12 }}>₹{mrpPrice.toFixed(2)}</span>
                              : <Typography sx={{ fontSize: 13 }}>₹{mrpPrice.toFixed(2)}</Typography>
                            }
                          </TableCell>
                          <TableCell align="right">
                            {hasDiscount ? (
                              <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#16a34a" }}>₹{ayujaPrice.toFixed(2)}</Typography>
                            ) : (
                              <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                                {offeredDiscountPct !== null ? `Up to ${offeredDiscountPct}% OFF` : `₹${mrpPrice.toFixed(2)}`}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Button size="large" variant="contained" startIcon={<Add sx={{ fontSize: 14 }} />}
                              onClick={(e) => { e.stopPropagation(); addMedicineToBill(med); }}
                              sx={{ bgcolor: "#006D77", textTransform: "none", fontSize: 11, py: 0.3, px: 1, minWidth: 0, "&:hover": { bgcolor: "#005A63" } }}>
                              Add
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </Paper>
          )}

          {/* Selected Items Preview */}
          <Paper elevation={0} sx={{ bgcolor: "#f8fafc", p: 2, mb: 3, maxHeight: 300, overflow: "auto" }}>
            <Grid container spacing={2}>
              {billItems.length > 0 ? (
                billItems.map((item) => {
                  const ayujaPrice = ayujaBillPrices[item.medicine_id];
                  const mrp = item.price || 0;
                  const hasAyuja = ayujaPrice !== undefined && ayujaPrice < mrp;
                  return (
                    <Grid item xs={12} sm={6} key={`selected-${item.medicine_id}`}>
                      <Card elevation={1} sx={{ p: 1.5, bgcolor: "#e0f2f1", border: "1px solid #d1fae5" }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1e293b" }}>{item.medicine_name}</Typography>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 0.5 }}>
                          <Box>
                            {hasAyuja ? (
                              <>
                                <Typography sx={{ fontSize: 11, color: "#9CA3AF", textDecoration: "line-through" }}>MRP ₹{mrp.toFixed(2)}</Typography>
                                <Typography sx={{ fontSize: 13, color: "#16a34a", fontWeight: 700 }}>₹{ayujaPrice.toFixed(2)}</Typography>
                              </>
                            ) : (
                              <Typography sx={{ fontSize: 12, color: "#64748b" }}>₹{mrp.toFixed(2)}</Typography>
                            )}
                          </Box>
                          <Typography sx={{ fontSize: 12, color: "#64748b" }}>Qty: {item.quantity}</Typography>
                        </Box>
                      </Card>
                    </Grid>
                  );
                })
              ) : (
                <Typography sx={{ p: 2, color: "#64748b" }}>No medicines selected</Typography>
              )}
            </Grid>
          </Paper>

          {/* Selected Items Table with AYUJA prices */}
          {billItems.length > 0 && (
            <>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Selected Medicines</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Medicine</TableCell>
                    <TableCell align="right">MRP</TableCell>
                    <TableCell align="right">AYUJA Price</TableCell>
                    <TableCell align="center">Quantity</TableCell>
                    <TableCell align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {billItems.map((item) => {
                    const ayujaPrice = ayujaBillPrices[item.medicine_id];
                    const mrp = item.price || 0;
                    const sellingPrice = ayujaPrice !== undefined ? ayujaPrice : mrp;
                    const hasAyuja = ayujaPrice !== undefined && ayujaPrice < mrp;
                    const discPct = hasAyuja ? (((mrp - ayujaPrice) / mrp) * 100).toFixed(1) : null;
                    return (
                      <TableRow key={`bill-item-${item.medicine_id}`}>
                        <TableCell>{item.medicine_name}</TableCell>
                        <TableCell align="right">
                          {hasAyuja
                            ? <span style={{ textDecoration: "line-through", color: "#9CA3AF" }}>₹{mrp.toFixed(2)}</span>
                            : `₹${mrp.toFixed(2)}`}
                        </TableCell>
                        <TableCell align="right">
                          <Typography sx={{ color: "#16a34a", fontWeight: 700, fontSize: 14 }}>
                            ₹{sellingPrice.toFixed(2)}
                          </Typography>
                          {discPct && (
                            <Chip label={`${discPct}% OFF`} size="small"
                              sx={{ fontSize: "0.65rem", bgcolor: "#fff7ed", color: "#ea580c", border: "1px solid #fed7aa", height: 18 }} />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                            <IconButton size="small" onClick={() => updateQuantity(item.medicine_id, item.quantity - 1)}><Remove fontSize="small" /></IconButton>
                            <Typography sx={{ minWidth: 30, textAlign: "center" }}>{item.quantity}</Typography>
                            <IconButton size="small" onClick={() => updateQuantity(item.medicine_id, item.quantity + 1)}><Add fontSize="small" /></IconButton>
                          </Box>
                        </TableCell>
                        <TableCell align="right">₹{(sellingPrice * item.quantity).toFixed(2)}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>

              <Divider sx={{ my: 2 }} />

              {/* Charges */}
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField fullWidth label="Delivery Charge" type="number" value={deliveryCharge} onChange={(e) => setDeliveryCharge(e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }} />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label="Additional Discount" type="number" value={discount} onChange={(e) => setDiscount(e.target.value)}
                    InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }} />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Notes (Optional)" multiline rows={2} value={notes} onChange={(e) => setNotes(e.target.value)} />
                </Grid>
              </Grid>

              {/* Summary */}
              <Paper elevation={0} sx={{ bgcolor: "#f8fafc", p: 2, mt: 2 }}>
                {getAyujaSavings() > 0 && (
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography sx={{ color: "#16a34a" }}>MRP Subtotal:</Typography>
                    <Typography sx={{ textDecoration: "line-through", color: "#9CA3AF" }}>₹{getMrpSubtotal().toFixed(2)}</Typography>
                  </Box>
                )}
                {getAyujaSavings() > 0 && (
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                    <Typography sx={{ color: "#16a34a" }}>AYUJA Savings:</Typography>
                    <Typography fontWeight={700} sx={{ color: "#16a34a" }}>-₹{getAyujaSavings().toFixed(2)}</Typography>
                  </Box>
                )}
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography>AYUJA Subtotal:</Typography>
                  <Typography fontWeight={600}>₹{getAyujaSubtotal().toFixed(2)}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography>Delivery Charge:</Typography>
                  <Typography fontWeight={600}>₹{parseFloat(deliveryCharge || 0).toFixed(2)}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography>Additional Discount:</Typography>
                  <Typography fontWeight={600} color="error">-₹{parseFloat(discount || 0).toFixed(2)}</Typography>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h6" fontWeight={700}>Total:</Typography>
                  <Typography variant="h6" fontWeight={700} color="#006D77">₹{calculateTotal().toFixed(2)}</Typography>
                </Box>
                {(getAyujaSavings() + parseFloat(discount || 0)) > 0 && (
                  <Box sx={{ mt: 1, p: 1, bgcolor: "#f0fdf4", borderRadius: 1, display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={{ fontSize: 13, color: "#16a34a", fontWeight: 700 }}>Total Savings:</Typography>
                    <Typography sx={{ fontSize: 13, color: "#16a34a", fontWeight: 700 }}>
                      ₹{(getAyujaSavings() + parseFloat(discount || 0)).toFixed(2)}
                    </Typography>
                  </Box>
                )}
              </Paper>
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setBillDialog(false)} sx={{ textTransform: "none" }}>Cancel</Button>
          <Button variant="contained" onClick={() => {setConfirmOpen(true)
            setSearchQuery("")
          }} disabled={billItems.length === 0}
            sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#005A63" } }}>
            Generate Bill
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Dialog */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Bill Generation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to generate the bill?</Typography>
          {getAyujaSavings() > 0 && (
            <Paper sx={{ mt: 2, p: 2, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2 }}>
              <Typography sx={{ color: "#16a34a", fontWeight: 600, fontSize: 14 }}>
                🎯 AYUJA pricing applied — customer saves ₹{getAyujaSavings().toFixed(2)}
              </Typography>
            </Paper>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button variant="contained" sx={{ bgcolor: "#006D77", "&:hover": { bgcolor: "#005A63" } }}
            onClick={() => { setConfirmOpen(false); handleGenerateBill(); }}>
            Yes, Generate
          </Button>
        </DialogActions>
      </Dialog>

      {/* ═══════════════════════════════════════════════════════════════════════
          ORDER DETAILS DIALOG
          ═══════════════════════════════════════════════════════════════════ */}
      <Dialog open={detailsDialog} onClose={() => setDetailsDialog(false)} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ bgcolor: "#006D77", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box>
            <Typography variant="h5" fontWeight="bold">{selectedOrder ? selectedOrder.order_id : "Loading..."}</Typography>
            {selectedOrder && (
              <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                <Chip label={selectedOrder.order_status} size="small" sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "white" }} />
              </Box>
            )}
          </Box>
          <IconButton onClick={() => setDetailsDialog(false)} sx={{ color: "white" }}><Close /></IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {!selectedOrder ? (
            <Typography>Loading...</Typography>
          ) : (
            <Box sx={{ py: 2, display: "flex", flexDirection: "column", gap: 3 }}>

              {/* CUSTOMER INFO */}
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PersonIcon sx={{ color: "#006D77" }} /> Customer Information
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {[
                    ["Name", selectedOrder.patient_details?.name],
                    ["Age", selectedOrder.patient_details?.age],
                    ["Gender", selectedOrder.patient_details?.gender],
                    ["Doctor", selectedOrder.patient_details?.doctorname],
                  ].map(([label, value]) => (
                    <Box key={label} sx={{ display: "flex", gap: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>{label}</Typography>
                      <Typography variant="body2" fontWeight="600">{value || "—"}</Typography>
                    </Box>
                  ))}
                  <Divider sx={{ my: 0.5 }} />
                  {[
                    ["Community", selectedOrder.delivery_address?.community_name],
                    ["Block", selectedOrder.delivery_address?.address_line1],
                    ["Flat No", selectedOrder.delivery_address?.address_line2],
                  ].map(([label, value]) => (
                    <Box key={label} sx={{ display: "flex", gap: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>{label}</Typography>
                      <Typography variant="body2" fontWeight="600">{value || "—"}</Typography>
                    </Box>
                  ))}
                  <Divider sx={{ my: 0.5 }} />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>Status</Typography>
                    <Chip label={selectedOrder.order_status} size="small"
                      sx={{ bgcolor: STATUS_COLORS[selectedOrder.order_status]?.bg, color: STATUS_COLORS[selectedOrder.order_status]?.text, fontWeight: 600, fontSize: "0.7rem", textTransform: "capitalize" }} />
                  </Box>
                  {selectedOrder.total_amount > 0 && (
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>Total</Typography>
                      <Typography variant="body2" fontWeight="700" color="#006D77">₹{selectedOrder.total_amount.toFixed(2)}</Typography>
                    </Box>
                  )}
                  {/* AYUJA summary from stored order */}
                  {selectedOrder.ayuja_summary && (
                    <Box sx={{ mt: 1, p: 1.5, bgcolor: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 2 }}>
                      <Typography sx={{ color: "#16a34a", fontWeight: 700, fontSize: 13 }}>🎯 AYUJA Pricing Applied</Typography>
                      <Box sx={{ display: "flex", gap: 3, mt: 0.5, flexWrap: "wrap" }}>
                        {selectedOrder.ayuja_summary.alpha && (
                          <Typography sx={{ fontSize: 12, color: "#9a3412" }}>Alpha: {selectedOrder.ayuja_summary.alpha}</Typography>
                        )}
                        {selectedOrder.ayuja_summary.final_discount_pct && (
                          <Typography sx={{ fontSize: 12, color: "#9a3412" }}>Discount: {selectedOrder.ayuja_summary.final_discount_pct}%</Typography>
                        )}
                        {selectedOrder.ayuja_summary.total_savings && (
                          <Typography sx={{ fontSize: 12, color: "#16a34a", fontWeight: 700 }}>Saved: ₹{Number(selectedOrder.ayuja_summary.total_savings).toFixed(2)}</Typography>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Paper>

              {/* ── ORDER PRICING SUMMARY ─────────────────────────────────────── */}
              {selectedOrder.order_pricing && (
                <Paper variant="outlined" sx={{ p: 4, border: "1px solid #e0e0e0", borderRadius: 2 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
                    <Typography variant="h6" sx={{ color: "#263238", fontWeight: 700, letterSpacing: "-0.5px" }}>
                      Order Pricing Summary
                    </Typography>
                    <Chip
                      label={`Alpha: ${selectedOrder.order_pricing.alpha ?? 0}`}
                      variant="outlined"
                      size="small"
                      sx={{ borderRadius: 1, fontWeight: "bold" }}
                    />
                  </Box>

                  <Grid container spacing={6}>
                    {/* Left: Revenue & Costs */}
                    <Grid item xs={12} md={7}>
                      <TableContainer component={Box}>
                        <Table size="small">
                          <TableBody>
                            {[
                              { label: "Total MRP",              value: selectedOrder.order_pricing.totalMRP },
                              { label: "Total Base Price",        value: selectedOrder.order_pricing.totalBP },
                              { label: "Total Discount Value",    value: selectedOrder.order_pricing.totalDiscountValue,      color: "error.main" },
                              { label: "Max Discount Amount",     value: selectedOrder.order_pricing.orderMaxDiscountAmount },
                            ].map((row) => (
                              <TableRow key={row.label} sx={{ "& td": { borderBottom: "1px solid #f5f5f5", py: 1.5, px: 0 } }}>
                                <TableCell sx={{ color: "text.secondary", fontWeight: 500 }}>{row.label}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 600, color: row.color || "inherit" }}>
                                  ₹{(row.value ?? 0).toLocaleString()}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>

                    {/* Right: Performance Indicators */}
                    <Grid item xs={12} md={5}>
                      <Box sx={{ bgcolor: "#F8FAFC", p: 3, borderRadius: 2, height: "100%" }}>
                        <Box display="flex" flexDirection="column" gap={2.5}>
                          <Box display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="text.secondary">Final Selling Price</Typography>
                            <Typography variant="body1" fontWeight="700" color="success.main">
                              ₹{(selectedOrder.order_pricing.totalSellingRevenue ?? 0).toLocaleString()}
                            </Typography>
                          </Box>
                          <Box display="flex" justifyContent="space-between">
                            <Typography variant="body2" color="text.secondary">Total Profit</Typography>
                            <Typography variant="body1" fontWeight="700" color="#006D77">
                              ₹{(selectedOrder.order_pricing.totalProfitValue ?? 0).toLocaleString()}
                            </Typography>
                          </Box>
                          <Divider />
                          <Box>
                            <Typography variant="caption" display="block" color="text.secondary" gutterBottom>
                              PROFIT MARGIN ON BP
                            </Typography>
                            <Typography variant="h4" sx={{ color: "#006D77", fontWeight: 800 }}>
                              {selectedOrder.order_pricing.finalProfitPercentOnBP ?? 0}%
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Footer: Discount Logic */}
                  <Box sx={{ mt: 4, pt: 3, borderTop: "1px dashed #e0e0e0" }}>
                    <Grid container spacing={4}>
                      {[
                        { label: "Allowed Disc. %",         value: selectedOrder.order_pricing.finalAllowedDiscountPercent },
                        { label: "Profit Protected %",       value: selectedOrder.order_pricing.profitProtectedMaxDiscountPercent },
                        { label: "Actual Max Disc. %",       value: selectedOrder.order_pricing.orderMaxDiscountPercent },
                      ].map((item) => (
                        <Grid item xs={4} key={item.label}>
                          <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", fontWeight: 600 }}>
                            {item.label}
                          </Typography>
                          <Typography variant="body1" fontWeight="600">{item.value ?? 0}%</Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Paper>
              )}

              {/* ── MEDICINES ORDERED (full detail table) ────────────────────── */}
              {selectedOrder.items?.length > 0 && (
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <DescriptionIcon sx={{ color: "#006D77" }} /> Medicines Ordered
                    </Typography>
                    <Button variant="contained" size="small" startIcon={<DownloadIcon />} onClick={handlePrintInvoice}
                      sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#005A63" } }}>
                      Print Invoice
                    </Button>
                  </Box>

                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ bgcolor: "#F0F9FF" }}>
                          <TableCell><strong>#</strong></TableCell>
                          <TableCell><strong>Medicine Name</strong></TableCell>
                          <TableCell align="center"><strong>Qty</strong></TableCell>
                          <TableCell align="right"><strong>MRP</strong></TableCell>
                          <TableCell align="right"><strong>Base Price</strong></TableCell>
                          <TableCell align="right"><strong>Selling Price</strong></TableCell>
                          <TableCell align="right"><strong>Discount%</strong></TableCell>
                          <TableCell align="right"><strong>GST%</strong></TableCell>
                          <TableCell align="right"><strong>Discount Amt</strong></TableCell>
                          <TableCell align="right"><strong>Profit</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedOrder.items.map((item, idx) => {
                          const itemGST = calculateItemGST(item);
                          return (
                            <React.Fragment key={`order-item-${idx}`}>
                              <TableRow>
                                <TableCell>{idx + 1}</TableCell>
                                <TableCell>
                                  <Typography variant="body2" fontWeight="600">{item.medicine_name}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Chip label={item.quantity} size="small" color="primary" sx={{ fontWeight: "bold" }} />
                                </TableCell>
                                <TableCell align="right">
                                  ₹{(item.price || 0).toFixed(2)}
                                </TableCell>
                                <TableCell align="right">
                                  ₹{itemGST.basePrice.toFixed(2)}
                                </TableCell>
                                <TableCell align="right">
                                  ₹{(item.total_price || 0).toFixed(2)}
                                </TableCell>
                                <TableCell align="right">
                                  {(item.applied_discount_pct || 0).toFixed(2)}%
                                </TableCell>
                                <TableCell align="right">
                                  <Chip label={`${itemGST.gstRate}%`} size="small"
                                    sx={{ bgcolor: "#E3F2FD", color: "#1976D2", fontWeight: "bold" }} />
                                </TableCell>
                                <TableCell align="right">
                                  ₹{(item.discount_value || 0).toFixed(2)}
                                </TableCell>
                                <TableCell align="right">
                                  ₹{(item.profit_value || 0).toFixed(2)}
                                </TableCell>
                              </TableRow>

                              {/* GST breakdown sub-row */}
                              <TableRow>
                                <TableCell colSpan={10} sx={{ py: 1, bgcolor: "#FAFAFA", borderBottom: idx === selectedOrder.items.length - 1 ? "2px solid #E0E0E0" : "1px solid #F0F0F0" }}>
                                  <Typography variant="caption" color="text.secondary">
                                    {itemGST.igst > 0
                                      ? <>IGST @ {itemGST.igst}%: ₹{itemGST.igstAmount.toFixed(2)}</>
                                      : <>CGST @ {itemGST.cgst}%: ₹{itemGST.cgstAmount.toFixed(2)} | SGST @ {itemGST.sgst}%: ₹{itemGST.sgstAmount.toFixed(2)}</>
                                    }
                                    {" | "}Base: ₹{(itemGST.basePrice / item.quantity).toFixed(2)}/unit × {item.quantity} = ₹{itemGST.basePrice.toFixed(2)} + GST ₹{itemGST.gstAmount.toFixed(2)} = ₹{itemGST.totalPrice.toFixed(2)}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* GST Summary */}
                  {(() => {
                    const orderGST = calculateOrderGST(selectedOrder.items);
                    return (
                      <Box sx={{ mt: 2, p: 2, bgcolor: "#F0F9FF", borderRadius: 1 }}>
                        <Typography variant="subtitle2" fontWeight="bold" color="#006D77" gutterBottom>GST Summary</Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6} sm={3}>
                            <Typography variant="caption" color="text.secondary">Base Amount</Typography>
                            <Typography variant="body1" fontWeight="bold">₹{orderGST.basePrice.toFixed(2)}</Typography>
                          </Grid>
                          {orderGST.cgst > 0 && (
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">CGST</Typography>
                              <Typography variant="body1" fontWeight="bold">₹{orderGST.cgst.toFixed(2)}</Typography>
                            </Grid>
                          )}
                          {orderGST.sgst > 0 && (
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">SGST</Typography>
                              <Typography variant="body1" fontWeight="bold">₹{orderGST.sgst.toFixed(2)}</Typography>
                            </Grid>
                          )}
                          {orderGST.igst > 0 && (
                            <Grid item xs={6} sm={3}>
                              <Typography variant="caption" color="text.secondary">IGST</Typography>
                              <Typography variant="body1" fontWeight="bold">₹{orderGST.igst.toFixed(2)}</Typography>
                            </Grid>
                          )}
                          <Grid item xs={6} sm={3}>
                            <Typography variant="caption" color="text.secondary">Total GST</Typography>
                            <Typography variant="body1" fontWeight="bold" color="#1976D2">₹{orderGST.totalGST.toFixed(2)}</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    );
                  })()}
                </Paper>
              )}

              {/* PRESCRIPTION FILES */}
              {prescriptionFiles.length > 0 && (
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <DescriptionIcon sx={{ color: "#006D77" }} /> Prescriptions
                  </Typography>
                  <List>
                    {prescriptionFiles.map((file, idx) => (
                      <ListItem key={`detail-prescription-${selectedOrder.order_id}-${idx}`} divider={idx < prescriptionFiles.length - 1} sx={{ px: 0 }}>
                        <ListItemIcon><DescriptionIcon sx={{ color: "#006D77" }} /></ListItemIcon>
                        <ListItemText primary={file.filename || `Prescription ${idx + 1}`} secondary={file.uploaded_at || ""} />
                        <Button size="small" startIcon={<Visibility />} onClick={() => openFileDialog(file.url)}
                          sx={{ color: "#006D77", "&:hover": { bgcolor: "rgba(0,109,119,0.08)" } }}>View</Button>
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              )}

              {/* DELIVERY AGENT */}
              {selectedOrder?.assigned_agent_id ? (
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PersonIcon sx={{ color: "#006D77" }} /> Assigned Delivery Agent
                  </Typography>
                  {loadingAgent ? (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}><CircularProgress size={40} sx={{ color: "#006D77" }} /></Box>
                  ) : agentDetails ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      {[
                        ["Agent ID", agentDetails.agentId],
                        ["Name", agentDetails.name],
                        ["Phone", agentDetails.phone],
                        ["Email", agentDetails.email],
                        ["Employee ID", agentDetails.employeeId],
                        ["Vehicle No", agentDetails.vehicleNumber],
                      ].map(([label, value]) => (
                        <Box key={label} sx={{ display: "flex", gap: 1 }}>
                          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 110 }}>{label}</Typography>
                          <Typography variant="body2" fontWeight="600">{value || "—"}</Typography>
                        </Box>
                      ))}
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ minWidth: 110 }}>Role</Typography>
                        <Chip label={agentDetails.agentRole === "delivery" ? "Delivery Agent" : "Sample Collection"} size="small"
                          sx={{ bgcolor: agentDetails.agentRole === "delivery" ? "#D1FAE5" : "#DBEAFE", color: agentDetails.agentRole === "delivery" ? "#059669" : "#2563EB", fontWeight: 600, fontSize: "0.7rem" }} />
                      </Box>
                      {agentDetails.address && (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 110 }}>Address</Typography>
                          <Typography variant="body2" fontWeight="600">
                            {[agentDetails.address.street, agentDetails.address.city,
                              agentDetails.address.state && agentDetails.address.pincode
                                ? `${agentDetails.address.state} - ${agentDetails.address.pincode}`
                                : agentDetails.address.state
                            ].filter(Boolean).join(", ")}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Typography sx={{ color: "#D97706", textAlign: "center", py: 2 }}>Agent details not available</Typography>
                  )}
                </Paper>
              ) : (
                <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f8fafc" }}>
                  <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PersonIcon sx={{ color: "#94a3b8" }} /> Delivery Agent
                  </Typography>
                  <Typography sx={{ color: "#64748b", textAlign: "center", py: 2 }}>No delivery agent assigned yet</Typography>
                </Paper>
              )}

              {/* DELIVERY ISSUES */}
              {selectedOrder?.delivery_issues && selectedOrder.delivery_issues.length > 0 && (
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Box sx={{ p: 2.5, display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}
                    onClick={() => {
                      const allIssueIds = selectedOrder.delivery_issues.map(i => i.issue_id);
                      const allExpanded = allIssueIds.every(id => expandedIssues[id]);
                      const newState = {};
                      allIssueIds.forEach(id => { newState[id] = !allExpanded; });
                      setExpandedIssues(newState);
                    }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box sx={{ width: 48, height: 48, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <DescriptionIcon sx={{ fontSize: 28 }} />
                      </Box>
                      <Box>
                        <Typography variant="h6" fontWeight="bold">Delivery Issues</Typography>
                        <Typography variant="body2" sx={{ opacity: 0.9 }}>{selectedOrder.delivery_issues.length} Total</Typography>
                      </Box>
                    </Box>
                    <Chip label={`${selectedOrder.delivery_issues.length} Issue${selectedOrder.delivery_issues.length > 1 ? "s" : ""}`}
                      sx={{ bgcolor: "#006D77", color: "white", fontWeight: 700, fontSize: "0.875rem" }} />
                  </Box>

                  <Box sx={{ bgcolor: "#FEFEFE" }}>
                    {selectedOrder.delivery_issues.map((issue, index) => {
                      const isExpanded = expandedIssues[issue.issue_id] || false;
                      const issueTypeFormatted = issue.issue_type?.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, l => l.toUpperCase()) || "N/A";
                      return (
                        <Box key={issue.issue_id || index} sx={{ borderBottom: index < selectedOrder.delivery_issues.length - 1 ? "1px solid #E5E7EB" : "none" }}>
                          <Box onClick={() => setExpandedIssues(prev => ({ ...prev, [issue.issue_id]: !isExpanded }))}
                            sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
                              <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#006D77", boxShadow: "0 0 0 3px #D1EEF0" }} />
                              <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 0.5 }}>
                                  <Typography variant="body1" fontWeight="700" color="#1F2937">{issue.issue_id}</Typography>
                                  <Chip label={issueTypeFormatted} size="small" sx={{ bgcolor: "#D1EEF0", fontWeight: 600, fontSize: "0.75rem", height: 22 }} />
                                  <Chip label={issue.status === "resolved" ? "Resolved" : issue.status === "in_progress" ? "In Progress" : "Open"} size="small"
                                    color={issue.status === "resolved" ? "success" : issue.status === "in_progress" ? "warning" : "error"}
                                    sx={{ fontWeight: 600, fontSize: "0.75rem", height: 22 }} />
                                </Box>
                                <Typography variant="caption" color="text.secondary">
                                  Reported {formatDate(issue.reported_at)} • By {issue.reported_by || "Unknown"}
                                </Typography>
                              </Box>
                            </Box>
                            <IconButton size="small" sx={{ color: "#6B7280", transition: "transform 0.2s", transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)" }}>
                              <Close sx={{ transform: isExpanded ? "rotate(45deg)" : "rotate(0deg)" }} />
                            </IconButton>
                          </Box>

                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <Box sx={{ p: 3, bgcolor: "#F9FAFB", borderTop: "1px solid #E5E7EB" }}>
                              <Grid container spacing={3}>
                                <Grid item xs={12}>
                                  <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>Issue Description</Typography>
                                  <Paper variant="outlined" sx={{ p: 2, bgcolor: "white", borderColor: "#E5E7EB" }}>
                                    <Typography variant="body2" color="#4B5563" sx={{ lineHeight: 1.6 }}>
                                      {issue.description || "No description provided"}
                                    </Typography>
                                  </Paper>
                                </Grid>
                                {issue.photo_url && (
                                  <Grid item xs={12} md={6}>
                                    <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>Photo Evidence</Typography>
                                    <Paper elevation={2} sx={{ position: "relative", overflow: "hidden", borderRadius: 2, cursor: "pointer", "&:hover": { transform: "scale(1.02)", boxShadow: 6 } }}
                                      onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`, "_blank")}>
                                      <Box component="img" src={`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`} alt="Issue evidence"
                                        sx={{ width: "100%", height: 250, objectFit: "cover" }} onError={(e) => { e.target.style.display = "none"; }} />
                                      <Box sx={{ position: "absolute", bottom: 0, left: 0, right: 0, bgcolor: "rgba(0,0,0,0.6)", color: "white", p: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        <Typography variant="caption" fontWeight="600">Click to view full size</Typography>
                                      </Box>
                                    </Paper>
                                  </Grid>
                                )}
                                <Grid item xs={12} md={issue.photo_url ? 6 : 12}>
                                  <Typography variant="subtitle2" fontWeight="700" color="#374151" gutterBottom>Issue Details</Typography>
                                  <Paper variant="outlined" sx={{ bgcolor: "white", borderColor: "#E5E7EB" }}>
                                    <List dense disablePadding>
                                      {[
                                        ["Issue ID", issue.issue_id],
                                        ["Type", issueTypeFormatted],
                                        ["Reported By", issue.reported_by || "Unknown"],
                                        ["Reported At", formatDate(issue.reported_at)],
                                      ].map(([label, value], i, arr) => (
                                        <ListItem key={label} divider={i < arr.length - 1}>
                                          <ListItemText
                                            primary={<Typography variant="caption" color="text.secondary">{label}</Typography>}
                                            secondary={<Typography variant="body2" fontWeight="600">{value}</Typography>}
                                          />
                                        </ListItem>
                                      ))}
                                      <ListItem>
                                        <ListItemText
                                          primary={<Typography variant="caption" color="text.secondary">Status</Typography>}
                                          secondary={
                                            <Chip label={issue.status === "resolved" ? "Resolved" : issue.status === "in_progress" ? "In Progress" : "Open"} size="small"
                                              color={issue.status === "resolved" ? "success" : issue.status === "in_progress" ? "warning" : "error"}
                                              sx={{ mt: 0.5, fontWeight: 600 }} />
                                          }
                                        />
                                      </ListItem>
                                    </List>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Box>
                          </Collapse>
                        </Box>
                      );
                    })}
                  </Box>

                  <Box sx={{ p: 2, bgcolor: "#F9FAFB", borderTop: "2px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="body2" color="text.secondary" fontWeight="500">Total Issues: {selectedOrder.delivery_issues.length}</Typography>
                    <Box sx={{ display: "flex", gap: 1.5 }}>
                      <Chip icon={<DescriptionIcon sx={{ fontSize: 16 }} />} label={`${selectedOrder.delivery_issues.filter(i => i.status === "open").length} Open`} size="small"
                        sx={{ bgcolor: "#FEE2E2", color: "#991B1B", fontWeight: 600 }} />
                    </Box>
                  </Box>
                </Paper>
              )}

              {/* TRANSACTION HISTORY */}
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>Transaction History</Typography>
                {selectedOrder.payment && (
                  <Box sx={{ p: 2, mb: 2, bgcolor: "#F0F9FF", borderRadius: 2, border: "1px solid #DBEAFE" }}>
                    <Grid container spacing={1}>
                      {[
                        ["Payment ID", selectedOrder.payment.payment_id || "N/A", true],
                        ["Method", (selectedOrder.payment.method || "N/A").toUpperCase(), false],
                        ["Amount", `${selectedOrder.payment.currency || "INR"} ₹${Number(selectedOrder.payment.amount || 0).toFixed(2)}`, false],
                        ["Status", (selectedOrder.payment.status || "N/A").toUpperCase(), false],
                      ].map(([label, value]) => (
                        <Grid item xs={6} sm={4} key={label}>
                          <Typography variant="caption" color="text.secondary">{label}</Typography>
                          <Typography variant="body2" fontWeight="600" sx={{ fontFamily: label === "Payment ID" ? "monospace" : "inherit", fontSize: label === "Payment ID" ? 12 : "inherit" }}>{value}</Typography>
                        </Grid>
                      ))}
                      {["created_at", "updated_at"].map(field => (
                        <Grid item xs={6} sm={4} key={field}>
                          <Typography variant="caption" color="text.secondary">{field === "created_at" ? "Created At" : "Last Updated"}</Typography>
                          <Typography variant="body2" fontWeight="600">
                            {selectedOrder.payment[field]
                              ? new Date(selectedOrder.payment[field]).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })
                              : "N/A"}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}

                {selectedOrder.payment?.transaction_history?.length > 0 ? (
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ bgcolor: "#F8FAFC" }}>
                          <TableCell><strong>#</strong></TableCell>
                          <TableCell><strong>Date & Time</strong></TableCell>
                          <TableCell><strong>Method</strong></TableCell>
                          <TableCell><strong>Amount</strong></TableCell>
                          <TableCell><strong>Status</strong></TableCell>
                          <TableCell><strong>Collected By</strong></TableCell>
                          <TableCell><strong>Notes</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedOrder.payment.transaction_history.map((txn, index) => (
                          <TableRow key={index} sx={{ bgcolor: index % 2 === 0 ? "#fff" : "#F8FAFC" }}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell sx={{ fontSize: 12 }}>
                              {txn.timestamp ? new Date(txn.timestamp).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }) : "—"}
                            </TableCell>
                            <TableCell>
                              <Chip label={(txn.method || "—").toUpperCase()} size="small" sx={{ bgcolor: "#DBEAFE", color: "#2563EB", fontWeight: 600, fontSize: "0.68rem" }} />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 700, color: "#006D77" }}>
                              {txn.amount !== undefined ? `₹${Number(txn.amount).toFixed(2)}` : "—"}
                            </TableCell>
                            <TableCell>
                              <Chip label={(txn.status || "—").replace(/_/g, " ").toUpperCase()} size="small"
                                sx={{
                                  bgcolor: ["paid_on_delivery", "paid", "success"].includes(txn.status) ? "#D1FAE5" : txn.status === "pending" ? "#FEF3C7" : "#FEE2E2",
                                  color: ["paid_on_delivery", "paid", "success"].includes(txn.status) ? "#059669" : txn.status === "pending" ? "#D97706" : "#DC2626",
                                  fontWeight: 600, fontSize: "0.68rem",
                                }} />
                            </TableCell>
                            <TableCell sx={{ fontSize: 12, fontFamily: "monospace" }}>{txn.collected_by || "—"}</TableCell>
                            <TableCell sx={{ fontSize: 12, color: "#64748B", maxWidth: 200 }}>{txn.notes || "—"}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography sx={{ color: "#94A3B8", fontSize: 14, textAlign: "center", py: 3 }}>No transaction history available</Typography>
                )}
              </Paper>

              {/* UPDATE ORDER STATUS */}
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>Update Order Status</Typography>
                <Grid container spacing={1}>
                  {["awaiting_bill", "bill_generated", "confirmed", "dispatched", "delivered", "cancelled"].map(status => (
                    <Grid item xs={6} key={status}>
                      <Button variant={selectedOrder.order_status === status ? "contained" : "outlined"} fullWidth
                        onClick={() => updateOrderStatus(selectedOrder.order_id, status)} disabled={updating}
                        sx={{
                          textTransform: "none", fontWeight: 600, borderColor: "#006D77",
                          color: selectedOrder.order_status === status ? "#fff" : "#006D77",
                          backgroundColor: selectedOrder.order_status === status ? "#006D77" : "transparent",
                          "&:hover": { backgroundColor: selectedOrder.order_status === status ? "#005560" : "rgba(0,109,119,0.08)", borderColor: "#006D77" },
                        }}>
                        {statusLabelMap[status]}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </Paper>

            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDetailsDialog(false)} variant="contained"
            sx={{ bgcolor: "#006D77", "&:hover": { bgcolor: "#005761" }, textTransform: "none" }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* FILE VIEWER DIALOG */}
      <Dialog open={fileDialog} onClose={() => setFileDialog(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Prescription File
          <IconButton onClick={() => setFileDialog(false)}><Close /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}><FileViewer /></DialogContent>
        <DialogActions sx={{ p: 2 }}>
          {selectedFile && (
            <Button variant="outlined" startIcon={<DownloadIcon />}
              onClick={() => handleDownloadPrescription(selectedOrder?.order_id, selectedFile)}
              sx={{ color: "#006D77", borderColor: "#006D77", textTransform: "none" }}>
              Download
            </Button>
          )}
          <Button onClick={() => setFileDialog(false)} sx={{ textTransform: "none" }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* NOTIFICATION DIALOG */}
      <CustomDialog
        open={dialog.open}
        onClose={() => setDialog({ ...dialog, open: false })}
        message={dialog.message}
        type={dialog.type}
        title={dialog.title}
      />
    </Container>
  );
}